import PropertiesMap from "./PropertiesMap";

export default PropertiesMap;
